import React from 'react';
import { bionicText } from '../../../../utils/bionicText';

const FeaturesSection = ({ FEATURE_LIST = [], bionicEnabled }) => {
  return (
    <div className="features-section">
      <h2 key="features-title">{bionicEnabled ? bionicText('Features') : 'Features'}</h2>
      <div className="features-grid" key="features-grid">
        {FEATURE_LIST.map((feature, index) => (
          <div 
            key={`feature-${feature.title}-${index}`}
            className="feature-item"
          >
            <div className="feature-card">
              <div className="feature-card-inner">
                <div className="feature-item-icon" key={`feature-icon-${index}`}>{feature.icon}</div>
                <h3 key={`feature-title-${index}`} className="feature-item-title">{bionicEnabled ? bionicText(feature.title) : feature.title}</h3>
                <p key={`feature-description-${index}`} className="feature-item-description">{bionicEnabled ? bionicText(feature.description) : feature.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(FeaturesSection);
